import React, {
  memo,
  ReactNode,
} from 'react';

import { checkTQConnectAccess } from '../../../shared/tqConnectUtils';
import TQUnlockPromptScreen from './TQUnlockPromptScreen';

interface Props {
  children: ReactNode;
}

/**
 * A wrapper component that checks if the user has access to TQ Connect.
 * If the user is a non-subscriber (doesn't have access), it shows the unlock prompt screen.
 * Otherwise, it renders the children (actual page content).
 */
const TQConnectAccessWrapper: React.FC<Props> = ({ children }) => {
  const { canViewTQConnectAsNonSubscriber } = checkTQConnectAccess();

  // Show unlock prompt screen for non-subscribers
  if (canViewTQConnectAsNonSubscriber) {
    return <TQUnlockPromptScreen />;
  }

  // Render the actual content for users with access
  return <>{children}</>;
};

export default memo(TQConnectAccessWrapper);
